export const T = {
  en_GB: {
    expectedReturn: "Expected Return",
    expectedVolatility: "Expected Volatility",
    firstDataPoint: "First",
    lastDataPoint: "Last",
    currency: "Currency",
    dataPoints: "Data Points",
    na: "N/A",
    loading: "Loading chart data...",
  },
  nb_NO: {
    expectedReturn: "Forventet avkastning",
    expectedVolatility: "Forventet volatilitet",
    firstDataPoint: "Første",
    lastDataPoint: "Siste",
    currency: "Valuta",
    dataPoints: "Datapunkter",
    na: "N/A",
    loading: "Laster diagramdata...",
  },
} as const;
